const identifyUser = ({ email }) => {
  if (!window.sib) return
  window.sib.email_id = email
}

export default {
  identifyUser,
}
